import { COLORS } from "../../../utils/js/constants";

export const balanceSheetStyle = (theme) => {

  return {
    root: {
      display: "flex",
    },
    content: {
      flexGrow: 1,
      height: "100vh",
      overflow: "auto",
      backgroundColor: 'black',
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
    },
    appBarSpacer: theme.mixins.toolbar,
    card: {
      display: 'flex',
      background: COLORS.grey,
      alignItems: 'center',
      margin: '1px 10px',
      border: 'solid #a0a0a0 1px',
      padding: '5px 15px',
      color: 'white',
      '&:hover': {
        backgroundColor: COLORS.darkGrey
      }
    },
    box: {
      display: 'flex',
      background: COLORS.lightGrey,
      justifyContent: 'space-between',
      margin: '0 10px 30px 10px',
      border: 'solid #a0a0a0 1px',
      borderRadius: 10,
      padding: 30,
      color: COLORS.lightYellow,
    },
    boxTitle: {
      fontSize: 25,
    },
    boxSubtitle: {
      fontSize: 15
    },
    header: {
      marginBottom: 5
    },
    productName: {
      flex: 3
    },
    productStock: {
      flex: 1,
      textAlign: 'center'
    },
    productAmount: {
      flex: 1,
      textAlign: 'center'
    },
  }
}
